import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SelecionarEmpresaComponent } from './selecionar-empresa.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: SelecionarEmpresaComponent }
    ])],
    exports: [RouterModule]
})
export class SelecionarEmpresaRoutingModule { }
